import { useMediaQuery } from 'react-responsive'

export default () => useMediaQuery({ query: ' (max-width: 65.98rem)' })
